<om-label *ngIf="label" [text]="label" [isRequired]="isRequired$ | async"></om-label>
<nz-upload [(nzFileList)]="fileList" [nzBeforeUpload]="beforeUpload" [nzRemove]="removeFile">
  <button nz-button [disabled]="fileList.length >= limit" nzSize="small">
    <i nz-icon nzType="upload"></i>
    Select File
  </button>
</nz-upload>
<div class="om-error-placeholder" *ngIf="control">
  <om-error *ngIf="showError" [control]="control"></om-error>
</div>
